<app-size-detector></app-size-detector>
<!-- begin:: Header Section -->
<div class="row header mb-1 mx-1">
  @if (showSelectAllCheckbox) {
    <mat-checkbox
      [disabled]="disableSelectAllCheckbox"
      class="select-all-checkbox"
      [(ngModel)]="selectAllCheckboxValue"
      (change)="onPressSelectAllCheckbox($event)"
      data-testid="dlt_checkbox_select_all"
      >Select All</mat-checkbox
      >
    }

    <!-- Begin:: Number of Results -->
    <span
      data-testid="dlt_label_showing_results"
      class="header__pagination-counter"
      >
      Showing {{ data.length | number }} out of {{ totalCount | number }}
      result(s)
    </span>
    <!-- End:: Number of Results -->

    <span class="spacer"></span>
    <!-- Begin:: Header Actions -->
    <span class="header__list-options">
      <!-- Begin:: Results Filter -->
      <div class="row d-flex align-items-center m-0 p-0">
        <div class="dlt-search-chip">
          <input
          [placeholder]="
            !!filterValue
              ? 'Filter (' + filteredData.length + ' found)'
              : 'Filter'
          "
            [(ngModel)]="filterValue"
            (keyup)="filterData()"
            type="text"
            data-testid="dlt_input_filter_results"
            />
            <div class="search-icons">
              <span matSuffix>
                <mat-icon class="prefix-icon">filter_list</mat-icon>
              </span>
              <button
                class="close-btn"
                aria-label="Clear"
                (click)="filterValue = ''; filterData(); filter = false"
                [ngClass]="{ show: filterValue }"
                data-testid="dlt_filter_results_btn_close"
                >
                <mat-icon class="prefix-icon">close</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- End:: Results Filter -->

        <div class="row m-0 p-0">
          <!-- Begin:: Add to Collections -->
          @if (getAllButtonEnabled) {
            <button
              mat-icon-button
              matTooltip="Add all into Collection"
              (click)="getAll()"
              data-testid="dlt_btn_add_to_collection"
              >
              @if (!generatingCsv) {
                <mat-icon>playlist_add</mat-icon>
              }
            </button>
          }
          <!-- End:: Add to Collections -->

          <!-- Begin:: Export to CSV -->
          @if (downloadButtonEnabled) {
            <button
              mat-icon-button
              matTooltip="Export as .csv file"
              (click)="exportAsCsv()"
              [disabled]="generatingCsv"
              data-testid="dlt_btn_export_to_csv"
              >
              @if (!generatingCsv) {
                <mat-icon
                  data-testid="dlt_btn_export_to_csv_generated"
                  >save_alt</mat-icon
                  >
              }
              @if (generatingCsv) {
                <mat-icon
                  data-testid="dlt_btn_export_to_csv_generating"
                  >
                  <mat-progress-spinner
                    [color]="'accent'"
                    [mode]="'indeterminate'"
                    [diameter]="30"
                    >
                  </mat-progress-spinner>
                </mat-icon>
              }
            </button>
          }
          <!-- End:: Export to CSV -->

          <!-- Begin: Column View Related -->
          @if (columnViewEnabled) {
            <span>
              <!-- Begin:: Enable List View -->
              @if (columnView) {
                <button
                  mat-icon-button
                  matTooltip="List View"
                  (click)="onClickListView()"
                  data-testid="dlt_btn_list_view"
                  >
                  <mat-icon>reorder</mat-icon>
                </button>
              }
              <!-- End:: Enable List View -->
              <!-- Begin:: Enable Column View -->
              @if (!columnView) {
                <button
                  mat-icon-button
                  matTooltip="Column View"
                  (click)="onClickColumnView()"
                  data-testid="dlt_btn_column_view"
                  >
                  <mat-icon>view_column</mat-icon>
                </button>
              }
              <!-- End:: Enable Column View -->
            </span>
          }
          <!-- End: Column View Related -->

          <!-- Begin:: Collapse All -->
          @if (expandAll) {
            <button
              mat-icon-button
              matTooltip="Collapse All"
              (click)="onClickCollapseAll()"
              data-testid="dlt_btn_collapse_all"
              >
              <mat-icon>unfold_less</mat-icon>
            </button>
          }
          <!-- End:: Collapse All -->

          <!-- Begin:: Expand All -->
          @if (!expandAll) {
            <button
              mat-icon-button
              matTooltip="Expand All"
              (click)="onClickExpandAll()"
              data-testid="dlt_btn_expand_all"
              >
              <mat-icon>unfold_more</mat-icon>
            </button>
          }
          <!-- End:: Expand All -->
        </div>
      </span>
      <!-- End:: Header Actions -->
    </div>
    <!-- End:: Header Section -->

    <!-- Begin:: Table View -->
    @if (!columnView) {
      <mat-accordion [multi]="true">
        @for (items of filteredData; track items; let i = $index) {
          <div
            [class.check-box-container]="items?.checkBoxConfig?.isVisible"
            attr.data-testid="dlt_card_{{ i }}"
            >
            @if (items?.checkBoxConfig?.isVisible && items.checkBoxConfig) {
              <mat-checkbox
      [disabled]="
        (items && items.loading) || (items?.checkBoxConfig?.isDisabled ?? false)
      "
                [(ngModel)]="items.checkBoxConfig.isSelected"
                class="mr-2"
                [class.check-box-container__check-box]="items?.checkBoxConfig?.isVisible"
                (change)="onCheckBoxClicked($event, items, i)"
                attr.data-testid="dlt_{{ i }}_checkbox_is_selected"
                >
              </mat-checkbox>
            }
            <mat-expansion-panel
              #panel
      [class.check-box-container__expansion-panel]="
        items?.checkBoxConfig?.isVisible
      "
              [disabled]="items && items.loading"
              (opened)="onExpandElement(items.index + 1)"
              (closed)="onCollapseElement(items.index + 1)"
              [expanded]="items && !items.loading && (items.expanded || expandAll)"
              attr.data-testid="dlt_{{ i }}_dlt_panel"
              >
              <!-- Begin:: Expansion Panel Header -->
              <mat-expansion-panel-header class="content__header">
                <!-- **** Icons are hidden for the Mobile view **** -->
                <mat-panel-title
                  class="w-100 mx-0"
                  [ngClass]="{ 'dlt-header': !panel?.expanded }"
                  attr.data-testid="dlt_{{ i }}_dlt_panel_title"
                  >
                  <div class="content__header-row row w-100 m-0 p-0">
                    <!-- Begin:: Icon & Loading Spinner -->
                    @if (!isMobileView || alwaysShowIcon) {
                      <div
                        style="width: 8.33%; margin-top: 5px"
                        >
                        <!-- Begin:: Icon -->
                        @if (items && !items.avatar && !items.loading) {
                          <div>
                            @if (items && items.icon) {
                              <mat-icon
                                attr.data-testid="dlt_{{ i }}_dlt_panel_title_icon"
                                class="content__icon"
                                >
                                {{ items.icon }}
                              </mat-icon>
                            }
                            @if (!items || !items.icon) {
                              <mat-icon
                                attr.data-testid="dlt_{{ i }}_dlt_panel_title_icon_no_content"
                                class="content__icon"
                                >
                                label_important
                              </mat-icon>
                            }
                          </div>
                        }
                        <!-- End:: Icon -->
                        <!-- Begin:: Avatar -->
                        @if (items && items.avatar && !items.loading) {
                          <div
                            attr.data-testid="dlt_{{ i }}_dlt_panel_title_avatar"
                            >
                            <img
                              [src]="items.avatar"
                              class="content__avatar-image"
                              alt=""
                              attr.data-testid="dlt_{{ i }}_dlt_panel_title_avatar_image"
                              />
                            </div>
                          }
                          <!-- End:: Avatar -->
                          <!-- Begin:: Spinner -->
                          @if (items && items.loading) {
                            <mat-icon class="content__icon">
                              <mat-progress-spinner
                                [color]="'accent'"
                                [mode]="'indeterminate'"
                                [diameter]="30"
                  attr.data-testid="dlt_{{
                    i
                  }}_dlt_panel_title_progress_spinner"
                                >
                              </mat-progress-spinner>
                            </mat-icon>
                          }
                          <!-- End:: Spinner -->
                        </div>
                      }
                      <!-- Begin:: Loading Spinner for Mobile View -->
                      @if (isMobileView && !alwaysShowIcon && items && items.loading) {
                        <div
                          style="width: 8.33%"
                          >
                          <!-- Begin:: Spinner -->
                          <mat-icon>
                            <mat-progress-spinner
                              [color]="'accent'"
                              [mode]="'indeterminate'"
                              [diameter]="30"
                  attr.data-testid="dlt_{{
                    i
                  }}_dlt_panel_title_progress_spinner_mobile"
                              >
                            </mat-progress-spinner>
                          </mat-icon>
                          <!-- End:: Spinner -->
                        </div>
                      }
                      <!-- Begin:: Loading Spinner for Mobile View -->
                      <!-- End:: Icon & Loading Spinner -->
                      <!-- Begin:: First Element -->
                      <div
                        [ngStyle]="{ width: isMobileView ? '91.66%' : '41.66%' }"
                        class="px-0"
                        style="margin-top: 5px"
                        [class.pl-4]="isMobileView && items.loading"
                        >
                        <!-- The content that previously was here, is now in ./dlt-elements-old/dlt-element-1.html -->
                        @if (items?.data?.[0]) {
                          <dlt-single-element
                            [panel]="panel"
                            [item]="items.data[0]"
                            [headerRow]="true"
                            (onDataElementClickAction)="dataElementActionClicked($event, 0)"
                attr.data-testid="dlt_{{ i }}_dlt_first_element_{{
                  items.data[0].key?.toLowerCase()?.replaceAll(' ', '_')
                }}"
                          ></dlt-single-element>
                        }
                      </div>
                      <!-- End:: First Element -->
                      <!-- Begin:: Second Element -->
                      <!-- **** Second Element for Mobile view in Contents Sections -->
                      @if (!isMobileView) {
                        <div style="width: 50%; margin-top: 5px">
                          <!-- The content that previously was here, is now in ./dlt-elements-old/dlt-element-2.html -->
                          @if (items?.data?.[1]) {
                            <dlt-single-element
                              [panel]="panel"
                              [item]="items.data[1]"
                              [headerRow]="true"
                              (onDataElementClickAction)="dataElementActionClicked($event, 1)"
                attr.data-testid="dlt_{{ i }}_dlt_second_element_{{
                  items.data[1].key?.toLowerCase()?.replaceAll(' ', '_')
                }}"
                            ></dlt-single-element>
                          }
                        </div>
                      }
                      <!-- End:: Second Element -->
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <!-- End:: Expansion Panel Header -->
                <!-- Begin:: Expansion Panel Body -->
                <ng-template matExpansionPanelContent>
                  <div class="row">
                    <!-- Begin:: Second Element for Mobile View -->
                    @if (isMobileView) {
                      <div class="w-100 pl-3">
                        <!-- The content that previously was here, is now in ./dlt-elements-old/dlt-element-2-mobile.html -->
                        @if (items?.data?.[1]) {
                          <dlt-single-element
                            [panel]="panel"
                            [item]="items.data[1]"
                            [headerRow]="true"
                            (onDataElementClickAction)="dataElementActionClicked($event, 1)"
              attr.data-testid="dlt_{{ i }}_dlt_second_element_mobile{{
                items.data[1].key?.toLowerCase()?.replaceAll(' ', '_')
              }}"
                          ></dlt-single-element>
                        }
                      </div>
                    }
                    <!-- End:: Second Element for Mobile View -->
                    <!-- Begin:: Body Contents -->
                    <!--
                    ****
                    When implementing new content view; add it to the
                    1. Full Width Content View
                    2. Content with Separator
                    3. Typical Content View
                    ****
                    -->
                    @if ((items?.data?.length ?? 0) > 2) {
                      <!-- **** First Two Items were Removed; Displayed in Above Sections **** -->
                      @for (item of items.data | slice : 2; track item; let j = $index) {
                        <div
                          class="pl-3"
              [class.w-33]="
                !isMobileView &&
                !(item && item.type && item.type === 'separator') &&
                !item.fullWidthColumn
              "
              [class.w-100]="
                isMobileView ||
                (item && item.type && item.type === 'separator') ||
                !!item.fullWidthColumn
              "
                          >
                          <!-- The content that previously was here, is now in ./dlt-elements-old/dlt-element-main.html -->
                          @if (item) {
                            <dlt-single-element
                              [panel]="panel"
                              [item]="item"
                              (onDataElementClickAction)="dataElementActionClicked($event, i)"
                attr.data-testid="dlt_{{ i }}_dlt_element_{{
                  items.data[2 + j].key?.toLowerCase()?.replaceAll(' ', '_')
                }}"
                (expansionPanelActionElementClickAction)="
                  onExpandedElementActionClick($event, j + 2, i)
                "
                            ></dlt-single-element>
                          }
                        </div>
                      }
                    }
                    <!-- End:: Body Contents -->
                  </div>
                  <!-- Begin:: Action Buttons -->
                  @if (
                    items.actions && items.actions !== [] && items.actions.length > 0
                    ) {
                    <div
                      class="action-button__row"
                      style="display: flex; align-items: center"
                      >
                      @for (action of items.actions; track action) {
                        <span>
                          <!--Begin:: Group Action Buttons -->
                          @if (
                            !!action.groupButton &&
                            action.groupedActions !== [] &&
                            (action.groupedActions?.length ?? 0) > 0
                            ) {
                            <!-- Begin:: Main Action Button -->
                            <button
                              mat-flat-button
                              [matMenuTriggerFor]="createGroupAction"
                              class="group-buttons action-button"
                              [matTooltip]="action.tooltip"
                              [disabled]="action?.disabled"
                attr.data-testid="dlt_{{ i }}_dlt_action_btn_{{
                  action.face.toLowerCase().replaceAll(' ', '_')
                }}"
                              >
                              <span class="action-label">
                                <mat-icon>{{ action.icon }}</mat-icon>
                                <span class="action-text">{{ action.face }}</span>
                                <mat-icon matSuffix class="material-icons"
                                  >arrow_drop_down</mat-icon
                                  >
                                </span>
                              </button>
                              <!-- End:: Main Action Button -->
                              <!-- Begin:: Sub Actions -->
                              <mat-menu #createGroupAction="matMenu">
                                <div
                  [ngClass]="
                    action?.scrollbarEnabled ?? false ? 'custom-menu' : ''
                  "
                                  >
                                  @for (groupAction of action.groupedActions; track groupAction) {
                                    <!-- Begin:: Action button with text & icon -->
                                    @if (
                                      groupAction &&
                                      groupAction.icon &&
                                      groupAction.face &&
                                      !action.slideToggle
                                      ) {
                                      <button
                                        mat-menu-item
                                        class="group-buttons__contents"
                                        [matTooltip]="groupAction.tooltip"
                      (click)="
                        triggerAction(panel, groupAction, items.index + 1)
                      "
                                        [disabled]="items.loading || action?.disabled"
                      attr.data-testid="dlt_{{ i }}_dlt_group_action_btn_{{
                        groupAction.face.toLowerCase().replaceAll(' ', '_')
                      }}"
                                        >
                                        @if (groupAction.icon) {
                                          <mat-icon
                                            class="group-buttons__icons"
                                            >{{ groupAction.icon }}</mat-icon
                                            >
                                        }
                                        @if (groupAction.face) {
                                          <span>{{
                                            groupAction.face
                                          }}</span>
                                        }
                                      </button>
                                    }
                                    <!-- End:: Action button with text & icon -->
                                    <!-- Begin:: Action button with text only-->
                                    @if (
                                      groupAction &&
                                      groupAction.face &&
                                      !action.slideToggle &&
                                      !(groupAction.icon || groupAction.icon !== '')
                                      ) {
                                      <button
                                        mat-menu-item
                                        class="group-buttons__contents"
                                        [matTooltip]="groupAction.tooltip"
                      (click)="
                        triggerAction(panel, groupAction, items.index + 1)
                      "
                                        [disabled]="items.loading || action?.disabled"
                      attr.data-testid="dlt_{{ i }}_dlt_group_action_btn_{{
                        groupAction.face.toLowerCase().replaceAll(' ', '_')
                      }}"
                                        >
                                        @if (groupAction.face) {
                                          <span>{{
                                            groupAction.face
                                          }}</span>
                                        }
                                        @if (groupAction.icon) {
                                          <mat-icon
                                            class="group-buttons__icons"
                                            >{{ groupAction.icon }}</mat-icon
                                            >
                                          }
                                        </button>
                                      }
                                      <!-- End:: Action button with text only-->
                                      <!-- Begin:: Action button with icon only-->
                                      @if (
                                        groupAction &&
                                        groupAction.icon &&
                                        !action.slideToggle &&
                                        !(groupAction.face || groupAction.face !== '')
                                        ) {
                                        <button
                                          mat-menu-item
                                          class="group-buttons__contents"
                                          [matTooltip]="groupAction.tooltip"
                      (click)="
                        triggerAction(panel, groupAction, items.index + 1)
                      "
                                          [disabled]="items.loading || action?.disabled"
                      attr.data-testid="dlt_{{ i }}_dlt_group_action_btn_{{
                        groupAction.face.toLowerCase().replaceAll(' ', '_')
                      }}"
                                          >
                                          @if (groupAction.icon) {
                                            <mat-icon
                                              class="group-buttons__icons"
                                              >{{ groupAction.icon }}</mat-icon
                                              >
                                            }
                                          </button>
                                        }
                                        <!-- End:: Action button with icon only-->
                                        <!-- Begin:: Slide Toggle Action Button -->
                                        @if (
                                          groupAction &&
                                          groupAction.slideToggle &&
                                          groupAction.slideToggleConfig
                                          ) {
                                          <mat-slide-toggle
                                            color="primary"
                      (change)="
                        triggerAction(panel, groupAction, items.index + 1)
                      "
                                            [(ngModel)]="groupAction.slideToggleConfig.value"
                                            [matTooltip]="groupAction.tooltip"
                                            [disabled]="action?.disabled ?? false"
                                            class="slide-toggle group-buttons__contents"
                      attr.data-testid="dlt_{{ i }}_dlt_slide_toggle_{{
                        groupAction.tooltip.toLowerCase().replaceAll(' ', '_')
                      }}"
                                            >
                                            <span slide-toggle__text>{{
                                              groupAction?.slideToggleConfig?.value
                                              ? groupAction?.slideToggleConfig?.onText
                                              : groupAction?.slideToggleConfig?.offText
                                            }}</span>
                                          </mat-slide-toggle>
                                        }
                                        <!-- End:: Slide Toggle Action Button -->
                                      }
                                    </div>
                                  </mat-menu>
                                  <!-- End:: Sub Actions -->
                                }
                                <!--End:: Group Action Buttons -->
                                <!-- Begin:: None Group Action Buttons -->
                                @if (!action.groupButton) {
                                  <!-- Begin:: Action button with text & icon -->
                                  @if (
                                    action && action.icon && action.face && !action.slideToggle
                                    ) {
                                    <button
                                      class="action-button"
                                      mat-flat-button
                                      [matTooltip]="action.tooltip"
                                      (click)="triggerAction(panel, action, items.index + 1)"
                                      [disabled]="items.loading || action?.disabled"
                attr.data-testid="dlt_{{ i }}_dlt_action_{{
                  action.face.toLowerCase().replaceAll(' ', '_')
                }}"
                                      >
                                      @if (action.icon) {
                                        <mat-icon>{{ action.icon }}</mat-icon>
                                      }
                                      @if (action.face) {
                                        <span>{{ action.face }}</span>
                                      }
                                    </button>
                                  }
                                  <!-- End:: Action button with text & icon -->
                                  <!-- Being:: Action button with progress bar-->
                                  @if (action && action.progressBar && !action.slideToggle) {
                                    <button
                                      class="action-button action-button__progress-bar"
                                      mat-flat-button
                                      [matTooltip]="action.tooltip"
                                      [disabled]="action?.disabled"
                                      (click)="triggerAction(panel, action, items.index + 1)"
                attr.data-testid="dlt_{{ i }}_dlt_action_{{
                  action.tooltip.toLowerCase().replaceAll(' ', '_')
                }}"
                                      >
                                      <dlt-progress-bar
                                        [properties]="action.progressBar"
                                        ></dlt-progress-bar
                                        ><br />
                                        <div>
                                          <span class="action-button__progress-bar-tooltip">{{
                                            action.tooltip
                                          }}</span>
                                        </div>
                                      </button>
                                    }
                                    <!-- Being:: Action button with progress bar-->
                                    <!-- Begin:: Action button with text only-->
                                    @if (
                                      action &&
                                      action.face &&
                                      !(action.icon || action.icon !== '') &&
                                      !action.slideToggle
                                      ) {
                                      <button
                                        class="action-button"
                                        mat-flat-button
                                        [matTooltip]="action.tooltip"
                                        (click)="triggerAction(panel, action, items.index + 1)"
                                        [disabled]="items.loading || action?.disabled"
                attr.data-testid="dlt_{{ i }}_dlt_action_{{
                  action.tooltip.toLowerCase().replaceAll(' ', '_')
                }}"
                                        >
                                        @if (action.face) {
                                          <span>{{ action.face }}</span>
                                        }
                                        <mat-icon>{{ action.icon }}</mat-icon>
                                      </button>
                                    }
                                    <!-- End:: Action button with text only-->
                                    <!-- Begin:: Action button with icon only-->
                                    @if (
                                      action &&
                                      action.icon &&
                                      !(action.face || action.face !== '') &&
                                      !action.progressBar &&
                                      !action.slideToggle
                                      ) {
                                      <button
                                        class="action-button"
                                        mat-icon-button
                                        [matTooltip]="action.tooltip"
                                        (click)="triggerAction(panel, action, items.index + 1)"
                                        [disabled]="items.loading || action?.disabled"
                attr.data-testid="dlt_{{ i }}_dlt_action_icon_btn_{{
                  action.icon.toLowerCase().replaceAll(' ', '_')
                }}"
                                        >
                                        <mat-icon>{{ action.icon }}</mat-icon>
                                      </button>
                                    }
                                    <!-- End:: Action button with icon only-->
                                    <!-- Begin:: Slide Toggle Action Button -->
                                    @if (action && action.slideToggle && action.slideToggleConfig) {
                                      <mat-slide-toggle
                                        color="primary"
                                        (change)="triggerAction(panel, action, items.index + 1)"
                                        [(ngModel)]="action.slideToggleConfig.value"
                                        [matTooltip]="action.tooltip"
                                        [disabled]="action?.disabled ?? false"
                                        class="slide-toggle"
                attr.data-testid="dlt_{{ i }}_dlt_slide_toggle_{{
                  action.tooltip.toLowerCase().replaceAll(' ', '_')
                }}"
                                        >
                                        <span class="slide-toggle__text">{{
                                          action?.slideToggleConfig?.value
                                          ? action?.slideToggleConfig?.onText
                                          : action?.slideToggleConfig?.offText
                                        }}</span>
                                      </mat-slide-toggle>
                                    }
                                    <!-- End:: Slide Toggle Action Button -->
                                  }
                                  <!-- End:: None Group Action Buttons -->
                                </span>
                              }
                            </div>
                          }
                          <!-- End:: Action Buttons -->
                        </ng-template>
                        <!-- End:: Expansion Panel Body -->
                      </mat-expansion-panel>
                    </div>
                  }
                </mat-accordion>
              }
              <!-- End:: Table View -->

              <!-- Begin:: Column View -->
              @if (columnView && statesKey && states.length > 0) {
                <div>
                  <div cdkDropListGroup>
                    <div class="row flex-lg-nowrap mt-4 pb-4 pt-2 scrollbar">
                      @for (state of states; track state) {
                        <div
                          [class.col-12]="isMobileView"
                          [class.col-lg-4]="!isMobileView"
                          >
                          <mat-accordion [multi]="true">
                            <div class="state-header">Status</div>
                            <div class="state">{{ state | titlecase }}</div>
                            <div class="column-view-body scrollbar">
                              <div
                                cdkDropList
                                (cdkDropListDropped)="drop($event)"
                                [cdkDropListData]="getColumnDataList(state)"
                                class="drop-list"
                                [cdkDropListDisabled]="!draggable"
                                >
                                @for (items of getColumnDataList(state); track items) {
                                  <mat-expansion-panel
                                    #panel
                                    [disabled]="items && items.loading"
                [expanded]="
                  items && !items.loading && (items.expanded || expandAll)
                "
                                    cdkDrag
                                    >
                                    <!-- Begin:: Expansion Panel Header -->
                                    <mat-expansion-panel-header class="content__header">
                                      <mat-panel-title>
                                        <div class="col-sm-12">
                                          <div class="row">
                                            @if (!isMobileView || alwaysShowIcon) {
                                              <div
                                                class="col-sm-3 d-none d-sm-block"
                                                >
                                                @if (items && !items.avatar && !items.loading) {
                                                  <div>
                                                    @if (items && items.icon) {
                                                      <mat-icon
                                                        class="content__icon"
                                                        >{{ items.icon }}
                                                      </mat-icon>
                                                    }
                                                    @if (!items || !items.icon) {
                                                      <mat-icon
                                                        class="content__icon"
                                                        >
                                                        label_important
                                                      </mat-icon>
                                                    }
                                                  </div>
                                                }
                                                @if (items && items.avatar && !items.loading) {
                                                  <div>
                                                    <img
                                                      [src]="items.avatar"
                                                      class="content__avatar-image"
                                                      alt=""
                                                      />
                                                    </div>
                                                  }
                                                  @if (items && items.loading) {
                                                    <mat-icon
                                                      class="content__icon"
                                                      >
                                                      <mat-progress-spinner
                                                        [color]="'accent'"
                                                        [mode]="'indeterminate'"
                                                        [diameter]="30"
                                                        >
                                                      </mat-progress-spinner>
                                                    </mat-icon>
                                                  }
                                                </div>
                                              }
                                              <div
                                                [class.col-5]="!isMobileView"
                                                [class.col-11]="isMobileView"
                                                style="padding-left: 0px; padding-right: 0px"
                                                >
                                                @if (items?.data?.[0]) {
                                                  <dlt-single-element
                                                    [panel]="panel"
                                                    [item]="items.data[0]"
                                                    [headerRow]="true"
                            (onDataElementClickAction)="
                              dataElementActionClicked($event, 0)
                            "
                                                  ></dlt-single-element>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </mat-panel-title>
                                        @if (items && items.loading && isMobileView) {
                                          <mat-panel-description
                                            class="d-sm-none"
                                            >
                                            <mat-icon>
                                              <mat-progress-spinner
                                                [color]="'accent'"
                                                [mode]="'indeterminate'"
                                                [diameter]="30"
                                                >
                                              </mat-progress-spinner>
                                            </mat-icon>
                                          </mat-panel-description>
                                        }
                                      </mat-expansion-panel-header>
                                      <!-- End:: Expansion Panel Header -->
                                      <!-- Begin:: Expansion Panel Body -->
                                      <ng-template matExpansionPanelContent>
                                        <div class="row">
                                          <!-- Begin:: Contents for Mobile View -->
                                          @if (isMobileView) {
                                            <div
                                              class="col-sm-4 d-block d-sm-none"
                                              >
                                              @if (items?.data?.[1]) {
                                                <dlt-single-element
                                                  [panel]="panel"
                                                  [item]="items.data[1]"
                                                  [headerRow]="true"
                        (onDataElementClickAction)="
                          dataElementActionClicked($event, 1)
                        "
                                                ></dlt-single-element>
                                              }
                                            </div>
                                          }
                                          <!-- End:: Contents for Mobile View -->
                                          @if ((items?.data?.length ?? 0) > 2) {
                                            @for (item of items.data | slice : 2; track item) {
                                              <div
                        [class.col-sm-6]="
                          !isMobileView &&
                          !(item && item.type && item.type === 'separator') &&
                          !item.fullWidthColumn
                        "
                        [class.col-sm-12]="
                          isMobileView ||
                          (item && item.type && item.type === 'separator') ||
                          !!item.fullWidthColumn
                        "
                                                >
                                                @if (item) {
                                                  <dlt-single-element
                                                    [panel]="panel"
                                                    [item]="item"
                                                  ></dlt-single-element>
                                                }
                                              </div>
                                            }
                                          }
                                        </div>
                                        @if (items && items.images && items.images !== []) {
                                          <div class="row mt-3">
                                            @for (image of items.images; track image) {
                                              <div>
                                                <div class="col-sm-1">
                                                  <!-- <img class="zoom-in" [src]="image.thumb_url" style="max-width: 120px; max-height: 120px;">    -->
                                                  <!-- <app-image-with-loading [thumb]="image.thumb_url" [image]="image.image_url"> -->
                                                <!-- </app-image-with-loading> -->
                                              </div>
                                            </div>
                                          }
                                        </div>
                                      }
                                      <!-- Actions Buttons Related -->
                                      @if (items) {
                                        <div class="row action-button-row">
                                          <span>
                                            @if (
                                              items.actions &&
                                              items.actions !== [] &&
                                              items.actions.length > 0
                                              ) {
                                              <span
                                                >
                                                <!-- General Action Buttons -->
                                                @for (action of items.actions; track action) {
                                                  <span>
                                                    @if (!action.groupButton) {
                                                      <!-- Action button with text & icon -->
                                                      @if (
                                                        action &&
                                                        action.icon &&
                                                        action.face &&
                                                        !action.slideToggle
                                                        ) {
                                                        <button
                                                          class="action-button"
                                                          mat-flat-button
                                                          [matTooltip]="action.tooltip"
                              (click)="
                                triggerAction(panel, action, items.index + 1)
                              "
                                                          [disabled]="items.loading"
                                                          >
                                                          @if (action.icon) {
                                                            <mat-icon>{{
                                                              action.icon
                                                            }}</mat-icon>
                                                          }
                                                          @if (action.face) {
                                                            <span>{{ action.face }}</span>
                                                          }
                                                        </button>
                                                      }
                                                      <!-- Action button with progress bar-->
                                                      @if (
                                                        action &&
                                                        action.progressBar &&
                                                        !action.slideToggle
                                                        ) {
                                                        <button
                                                          class="action-button action-button__progress-bar"
                                                          mat-flat-button
                                                          [matTooltip]="action.tooltip"
                              (click)="
                                triggerAction(panel, action, items.index + 1)
                              "
                                                          >
                                                          <dlt-progress-bar
                                                            [properties]="action.progressBar"
                                                            ></dlt-progress-bar
                                                            ><br />
                                                            <div>
                                                              <span
                                                                class="action-button__progress-bar-tooltip"
                                                                >{{ action.tooltip }}</span
                                                                >
                                                              </div>
                                                            </button>
                                                          }
                                                          <!-- Action button with text only-->
                                                          @if (
                                                            action &&
                                                            action.face &&
                                                            !(action.icon || action.icon !== '') &&
                                                            !action.slideToggle
                                                            ) {
                                                            <button
                                                              class="action-button"
                                                              mat-flat-button
                                                              [matTooltip]="action.tooltip"
                              (click)="
                                triggerAction(panel, action, items.index + 1)
                              "
                                                              [disabled]="items.loading"
                                                              >
                                                              @if (action.face) {
                                                                <span>{{ action.face }}</span>
                                                              }
                                                              <mat-icon>{{ action.icon }}</mat-icon>
                                                            </button>
                                                          }
                                                          <!-- Action button with icon only-->
                                                          @if (
                                                            action &&
                                                            action.icon &&
                                                            !(action.face || action.face !== '') &&
                                                            !action.progressBar &&
                                                            !action.slideToggle
                                                            ) {
                                                            <button
                                                              class="action-button"
                                                              mat-icon-button
                                                              [matTooltip]="action.tooltip"
                              (click)="
                                triggerAction(panel, action, items.index + 1)
                              "
                                                              [disabled]="items.loading"
                                                              >
                                                              <mat-icon>{{ action.icon }}</mat-icon>
                                                            </button>
                                                          }
                                                          <!-- Slide Toggle Action Button -->
                                                          @if (
                                                            action &&
                                                            action.slideToggle &&
                                                            action.slideToggleConfig
                                                            ) {
                                                            <mat-slide-toggle
                                                              color="primary"
                              (change)="
                                triggerAction(panel, action, items.index + 1)
                              "
                                                              [(ngModel)]="action.slideToggleConfig.value"
                                                              [matTooltip]="action.tooltip"
                                                              class="slide-toggle"
                                                              >
                                                              <span class="slide-toggle__text">{{
                                                                action?.slideToggleConfig?.value
                                                                ? action?.slideToggleConfig?.onText
                                                                : action?.slideToggleConfig?.offText
                                                              }}</span>
                                                            </mat-slide-toggle>
                                                          }
                                                        }
                                                        <!-- End of General Action Buttons -->
                                                        <!-- Group Action Buttons -->
                                                        @if (
                                                          !!action.groupButton &&
                                                          action.groupedActions !== [] &&
                                                          (action.groupedActions?.length ?? 0) > 0
                                                          ) {
                                                          <!-- The button with hover for the web view -->
                                                          @if (!isMobileView) {
                                                            <button
                                                              mat-flat-button
                                                              #createGroupMenuTrigger="matMenuTrigger"
                                                              [matMenuTriggerFor]="createGroupAction"
                                                              class="group-buttons action-button"
                              (mouseover)="
                                createGroupMenuTrigger.openMenu();
                                $event.stopPropagation()
                              "
                                                              (mouseout)="$event.stopPropagation()"
                                                              [matTooltip]="action.tooltip"
                                                              >
                                                              <mat-icon>{{ action.icon }}</mat-icon>
                                                              {{ action.face }}
                                                              <mat-icon matSuffix class="material-icons"
                                                                >arrow_drop_down</mat-icon
                                                                >
                                                              </button>
                                                            }
                                                            <!-- The button without hover for the mobile view -->
                                                            @if (isMobileView) {
                                                              <button
                                                                mat-flat-button
                                                                [matMenuTriggerFor]="createGroupAction"
                                                                class="group-buttons action-button"
                                                                [matTooltip]="action.tooltip"
                                                                >
                                                                <mat-icon>{{ action.icon }}</mat-icon>
                                                                {{ action.face }}
                                                                <mat-icon matSuffix class="material-icons"
                                                                  >arrow_drop_down</mat-icon
                                                                  >
                                                                </button>
                                                              }
                                                              <!-- The Actions -->
                                                              <mat-menu #createGroupAction="matMenu">
                                                                @for (
                                                                  groupAction of action.groupedActions
                                                                  ; track
                                                                  groupAction) {
                                                                  <!-- Action button with text & icon -->
                                                                  @if (
                                                                    groupAction &&
                                                                    groupAction.icon &&
                                                                    groupAction.face &&
                                                                    !action.slideToggle
                                                                    ) {
                                                                    <button
                                                                      mat-menu-item
                                                                      class="group-buttons-contents"
                                                                      [matTooltip]="groupAction.tooltip"
                                  (click)="
                                    triggerAction(
                                      panel,
                                      groupAction,
                                      items.index + 1
                                    )
                                  "
                                                                      [disabled]="items.loading"
                                                                      >
                                                                      @if (groupAction.icon) {
                                                                        <mat-icon
                                                                          class="group-buttons-icons"
                                                                          >{{ groupAction.icon }}
                                                                        </mat-icon>
                                                                      }
                                                                      @if (groupAction.face) {
                                                                        <span>{{
                                                                          groupAction.face
                                                                        }}</span>
                                                                      }
                                                                    </button>
                                                                  }
                                                                  <!-- Action button with text only-->
                                                                  @if (
                                                                    groupAction &&
                                                                    groupAction.face &&
                                                                    !(
                                                                    groupAction.icon ||
                                                                    groupAction.icon !== ''
                                                                    ) &&
                                                                    !action.slideToggle
                                                                    ) {
                                                                    <button
                                                                      mat-menu-item
                                                                      class="group-buttons-contents"
                                                                      [matTooltip]="groupAction.tooltip"
                                  (click)="
                                    triggerAction(
                                      panel,
                                      groupAction,
                                      items.index + 1
                                    )
                                  "
                                                                      [disabled]="items.loading"
                                                                      >
                                                                      @if (groupAction.face) {
                                                                        <span>{{
                                                                          groupAction.face
                                                                        }}</span>
                                                                      }
                                                                      <mat-icon class="group-buttons-icons">{{
                                                                        groupAction.icon
                                                                      }}</mat-icon>
                                                                    </button>
                                                                  }
                                                                  <!-- Action button with icon only-->
                                                                  @if (
                                                                    groupAction &&
                                                                    groupAction.icon &&
                                                                    !(
                                                                    groupAction.face ||
                                                                    groupAction.face !== ''
                                                                    ) &&
                                                                    !action.slideToggle
                                                                    ) {
                                                                    <button
                                                                      mat-menu-item
                                                                      class="group-buttons-contents"
                                                                      [matTooltip]="groupAction.tooltip"
                                  (click)="
                                    triggerAction(
                                      panel,
                                      groupAction,
                                      items.index + 1
                                    )
                                  "
                                                                      [disabled]="items.loading"
                                                                      >
                                                                      <mat-icon class="group-buttons-icons">{{
                                                                        groupAction.icon
                                                                      }}</mat-icon>
                                                                    </button>
                                                                  }
                                                                  <!-- Slide Toggle Action Button -->
                                                                  @if (
                                                                    groupAction &&
                                                                    groupAction.slideToggle &&
                                                                    groupAction.slideToggleConfig
                                                                    ) {
                                                                    <mat-slide-toggle
                                                                      color="primary"
                                  (change)="
                                    triggerAction(
                                      panel,
                                      groupAction,
                                      items.index + 1
                                    )
                                  "
                                  [(ngModel)]="
                                    groupAction.slideToggleConfig.value
                                  "
                                                                      [matTooltip]="groupAction.tooltip"
                                                                      class="slide-toggle group-buttons-contents"
                                                                      >
                                                                      <span>{{
                                                                        groupAction?.slideToggleConfig?.value
                                                                        ? groupAction?.slideToggleConfig?.onText
                                                                        : groupAction?.slideToggleConfig?.offText
                                                                      }}</span>
                                                                    </mat-slide-toggle>
                                                                  }
                                                                }
                                                              </mat-menu>
                                                              <!-- End of Group Action Buttons -->
                                                            }
                                                          </span>
                                                        }
                                                      </span>
                                                    }
                                                    <!--End of Action Buttons -->
                                                  </span>
                                                </div>
                                              }
                                              <!-- End of Actions Buttons Related -->
                                            </ng-template>
                                            <!-- End:: Expansion Panel Body -->
                                          </mat-expansion-panel>
                                        }
                                      </div>
                                    </div>
                                  </mat-accordion>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      }
                      <!-- End:: Column View -->

                      <!-- Begin:: Footer -->
                      <div class="bottom-panel mt-3">
                        <!-- Begin:: Number of Results Selector -->
                        <div class="w-100">
                          @if (showMoreButtonEnabled && totalCount > data.length) {
                            <mat-select
                              class="bottom-panel__results-drop-down"
                              [(ngModel)]="pageSize"
                              (selectionChange)="pageSizeChanged($event)"
                              [disabled]="loadingShowMore"
                              data-testid="dlt_select_list_size"
                              hideSingleSelectionIndicator="true"
                              style="min-width: 100px"
                              >
                              @for (step of steps; track step) {
                                <mat-option
                                  [value]="step"
                                  attr.data-testid="dlt_select_list_size_option_{{ step }}"
                                  >{{ step }} results</mat-option
                                  >
                              }
                            </mat-select>
                          }
                        </div>
                        <!-- End:: Number of Results Selector -->

                        <!-- Begin:: Show More Button -->
                        <div class="w-100">
                          @if (showMoreButtonEnabled && totalCount > data.length) {
                            <button
                              class="bottom-panel__show-more-button"
                              mat-button
                              (click)="triggerShowMore()"
                              [disabled]="loadingShowMore"
                              data-testid="dlt_btn_show_more"
                              >
                              @if (loadingShowMore) {
                                <mat-icon>
                                  <mat-spinner diameter="20"> </mat-spinner> </mat-icon
                                  >
                                  }Show {{ pageSize }} More
                                </button>
                              }
                            </div>
                            <!-- End:: Show More Button -->
                          </div>
                          <!-- End:: Footer -->
